import reportsUrlConstants from '../../constants/reportsUrlConstants'
import { triageLevelStates } from '../../store/reports/types'

const reports = () => reportsUrlConstants.REPORTS_URL
const getReportById = (id: number) => `${reportsUrlConstants.REPORTS_URL}${id}/`

const getReportAnswers = (id: number) => `${reportsUrlConstants.REPORTS_URL}${id}/answers/`

const getCaseTypeQuestions = ({ caseType, caseId }: { caseType: string; caseId: string }) =>
  `${reportsUrlConstants.REPORTS_URL}${caseId}/questions/?type=${caseType}`

const postTriageLevel = (id: number, actionType: string) =>
  `${getReportById(id)}action/?call=${actionType}`

const getUsersReports = () => reportsUrlConstants.REPORT_ASSIGNS_URL_PER_USER

const getAdminReports = () => reportsUrlConstants.ADMIN_REPORTS

const getReportsRequiresTriage = () => `${reports()}?triage_level=all&requires_triage=true`
const getReportsArchived = () =>
  `${reports()}?triage_level=${triageLevelStates.ADDRESSED_AND_RESOLVED}`

const getTeamMembersUrl = (id: number) => `${reports()}${id}/team`

const getReportTypesUrl = () => reportsUrlConstants.REPORT_TYPES

const getStatusMessageUrl = () => reportsUrlConstants?.STATUS_UPDATES

const getResolvedReportsUrl = () => reportsUrlConstants?.RESOLVED_REPORTS

const getOutcomesUrl = () => reportsUrlConstants.OUTCOMES

const getDispositionsUrl = () => `${getResolvedReportsUrl()}dispositions`

const getReportAssignsUrl = () => reportsUrlConstants.REPORT_ASSIGNS_URL

export default {
  reports,
  getReportById,
  getReportAnswers,
  getCaseTypeQuestions,
  postTriageLevel,
  getUsersReports,
  getAdminReports,
  getReportsRequiresTriage,
  getReportsArchived,
  getTeamMembersUrl,
  getReportTypesUrl,
  getStatusMessageUrl,
  getResolvedReportsUrl,
  getOutcomesUrl,
  getDispositionsUrl,
  getReportAssignsUrl,
}
